export const toString = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }

  return JSON.stringify(value);
};

export const fromString = (value: string): unknown => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
